import axios from 'axios';
import { ThemeProvider } from '@emotion/react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { connect } from 'react-redux';
import { shapeInput, shapeSettings } from '../../tools/maxmortgage/config';
import analytics from '../utility/analytics';
import { PrimaryButton, PrimaryOutlineButton } from '../buttons';
import { Input } from '../inputs';
import { Heading, Loader } from '../components';
import { dispatchMapper } from '../wizard/actions';
import { ButtonContainer, LeadFormContainer, LeadFormInput, SuccessMessage } from './';

const fields = {
  first_name: 'Voornaam',
  last_name_prefix: 'Tussenvoegsel',
  last_name: 'Achternaam',
  email: 'E-mailadres',
  phone_number: 'Telefoonnummer',
};

const LeadFormRedux = ({
  app,
  input,
  sync,
  settings: { leadFormHeader, leadFormText, leadAddressInformation },
  onRequestClose,
  formIsLoading,
  setFormIsLoading,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const submitLead = e => {
    e.preventDefault();
    setFormIsLoading(true);
    axios({
      method: 'post',
      url: `/${app}/lead`,
      data: input,
    })
      .then(res => {
        if (res.data && res.data.length === 0) res.data = {};
        analytics.send('Verstuur formulier', 'Lead');
        setShowSuccess(true);
        analytics.send('Verstuur formulier', 'Verstuur');
      })
      .catch(error => {
        const { errors } = error.response.data || {};
        setErrors({ ...errors });
      })
      .finally(() => setFormIsLoading(false));
  };

  return (
    <ThemeProvider theme={{ cardColor: '#ffffff' }}>
      {showSuccess ? (
        <SuccessMessage onRequestClose={onRequestClose} />
      ) : (
        <LeadFormContainer>
          <form onSubmit={submitLead}>
            <Heading>{leadFormHeader}</Heading>
            <p>{leadFormText}</p>
            <LeadFormInput>
              {Object.entries(fields).map(([name, label], index) => (
                <Input
                  id={name}
                  key={name}
                  placeholder={label}
                  name={name}
                  value={input[name]}
                  onChange={sync(name)}
                  errors={errors[name]}
                  autoFocus={index === 0}
                />
              ))}

              {leadAddressInformation ? (
                  <>
                    <Input
                        name="postal_code"
                        value={input['postal_code']}
                        onChange={sync('postal_code')}
                        placeholder="12345AB"
                        errors={errors['postal_code']}
                    />

                    <Input
                        name="house_number"
                        value={input['house_number']}
                        onChange={sync('house_number')}
                        placeholder="123"
                        errors={errors['house_number']}
                    />

                    <Input
                        name="house_number_addition"
                        value={input['house_number_addition']}
                        onChange={sync('house_number_addition')}
                        placeholder="A"
                        errors={errors['house_number_addition']}
                    />
                  </>
              ) : (<></>)}
            </LeadFormInput>
            <ButtonContainer>
              <PrimaryOutlineButton onClick={onRequestClose} disabled={formIsLoading}>
                Annuleren
              </PrimaryOutlineButton>
              <PrimaryButton type="submit" disabled={formIsLoading}>
                {formIsLoading ? <Loader css={{ margin: 0 }} invertedColor /> : 'Verzenden'}
              </PrimaryButton>
            </ButtonContainer>
          </form>
        </LeadFormContainer>
      )}
    </ThemeProvider>
  );
};

LeadFormRedux.propTypes = {
  app: PropTypes.string.isRequired,
  sync: PropTypes.func.isRequired,
  input: shapeInput.isRequired,
  settings: shapeSettings,
  onRequestClose: PropTypes.func.isRequired,
};

LeadFormRedux.defaultProps = {
  settings: {},
};

export default connect(
  state => ({
    app: state.app,
    input: state.input,
    output: state.output,
    settings: state.settings,
  }),
  dispatchMapper
)(LeadFormRedux);
